import { DEBUG } from '@src/DEBUG';
DEBUG.open ( '/xs/service/ui-manager' );

import { Injectable } from '@angular/core';
import { XsIdentityInterface } from '../../interfaces/identify.interface';
import { Constants } from '@src/app/commons/Constants';
import { BehaviorSubject, Subject } from 'rxjs';

import * as _ from 'lodash';
import { FourDService } from '4d-mapper';
import { KeyValue } from '@angular/common';
import { MapService } from '@src/app/commons/map.service';
import { XsEventListenerInterface } from '../../interfaces/event-listener.interface';
import { XsApplicationEventsService } from '../events/application-events.service';
import { XsBaseClass } from '../../controllers/base.class';
import { FdmPlugin } from '@src/app/commons/plugins/plugins';

export class QuickGuideDisplay {
  screen:string
  show:boolean
}

export class XsSettings {
  name:string = null;
  items:any = {};
  constructor( name:string, incoming:any = null ) {
    this.name = name;
    if ( incoming ) {
      Object.keys(incoming).forEach ( key => {
        this.items[key] = incoming[key];
      });
    }
  }
  getToken(key:string) {
    return '__setting_'+this.name+'_'+key;
  }
  peek ( item:any ) {
    // console.log('## peek',item);
    if ( item ) {
      Object.keys(this.items).forEach ( key => {
        let token = this.getToken(key);
        if ( item.hasOwnProperty(token) ) {
          this.items[key] = item[token];
          // console.log('## peek FOUND',token,item[token]);
        } 
      });
    }
  }
  poke ( item:any ) {
    // console.log('## poke',item);
    if ( item ) {
      Object.keys(this.items).forEach ( key => {
        let token = this.getToken(key);
        item[token] = this.items[key];
        // console.log('## poke POKED',token,item[token]);
      });
    }
  }
  isShowing(key:string) {
    if ( this.items[key] && this.items[key].show ) {
      return true;
    }
    return false;
  }
  setShow(key:string, state:boolean = true ) {
    if ( this.items[key] ) {
      this.items[key]['show'] = state;
    }
  }
  toggleShow(key:string ) {
    if ( this.items[key] ) {
      if ( !this.items[key].hasOwnProperty('show') ) {
        this.items[key]['show'] = false;
      }
      this.items[key]['show'] = !this.items[key]['show'];
    }
  }
}

export class UiPanel extends XsBaseClass {

  uiManager:UiManagerService = null;

  id:string = null;
  class:string = '';
  labelToken:string = '';
  show:boolean = false;
  items:any[] = [];
  controller:any = null;
  plugin:any = null;

  constructor ( config:any = {} ) {
    super(config);
    if ( !this._config.id ) {
      this.id = this.__uuidv4('_','panel_');
    } else {
      this.id = this._config.id;
    }
  }



}

@Injectable({
  providedIn: 'root'
})
export class UiManagerService implements XsIdentityInterface, XsEventListenerInterface {

  __ID = null;
  __EVENTS = null;

  debug:boolean = Constants.debug_off;
  debugCounter:number = 0;

  static PANEL = 'panel';
  static INFOBOX = 'infobox';

  // main mode (for advanced, normal, simple views)
  uiMode:string = 'normal';
  uiModeHideSimple:boolean = false;
  uiModeSwitch:boolean = false;

  uiModes:any[] = [
    { id:'normal', labelToken:'NAV.NORMAL_MODE', icon:'expand' }, 
    { id:'simple', labelToken:'NAV.SIMPLE_MODE', icon:'compress' },
    { id:'navigator', labelToken:'NAV.NAVIGATOR_MODE', icon:'directions' }
  ];

  viewSection:XsSettings = new XsSettings( 'view', {
    // 'jobs': { labelToken:'NAV.SECTION_JOBS', show:true, icon:'expand' },
    'environment': { labelToken:'NAV.SECTION_ENVIRONMENT', show:true, icon:'expand' },
    'files': { labelToken:'NAV.SECTION_FILES', show:true, icon:'expand' },
    'bookmarks': { labelToken:'NAV.SECTION_BOOKMARKS', show:true, icon:'expand' },
    'photos': { labelToken:'NAV.SECTION_PHOTOS', show:true, icon:'expand' },
    // 'legends': { labelToken:'NAV.SECTION_LEGENDS', show:true, icon:'expand' },
    'incoming': { labelToken:'NAV.SECTION_INCOMING', show:true, icon:'expand' },
    'basemap': { labelToken:'NAV.SECTION_BASEMAP', show:true, icon:'expand' },
    'terrain': { labelToken:'NAV.SECTION_TERRAIN', show:true, icon:'expand' },
    'layers': { labelToken:'NAV.SECTION_LAYERS', show:true, icon:'expand' },
  });

  // all our UI panels
  panelRegistry:any = {}; // old

  panels:any = {};
  panelsActive:any[] = [];

  // short-list of only active (show) panels
  activePanels:any = [];


  // This is for all Quick Guides on the different screens
  private toggleQuickGuide = new BehaviorSubject<QuickGuideDisplay>(null);
  toggleQuickGuide$ = this.toggleQuickGuide.asObservable();

  constructor ( public applicationEvents: XsApplicationEventsService, public fourD: FourDService, public mapService: MapService ) {
    DEBUG.log ( '/xs/service/ui-manager' );
    this.__ID = XsIdentityInterface.__init(this);
    this.__EVENTS = XsEventListenerInterface.__init(this);
    if ( this.debug ) { console.log ( "%c UiManager CONSTRUCTOR()", Constants._yellow, this.debug ); }
  }

  // listen out for scene changes; user props might be stored there
  ___sceneChangeProcess ( scene:any = null ) {
    if ( scene ) {
      this.viewSection.peek(this.mapService.currentProject.props);
    }
  }

  toggleSection(id) {
    this.viewSection.toggleShow(id);
    this.viewSection.poke(this.mapService.currentProject.props);
    this.mapService.currentProject.saveObservable().subscribe();
    // console.log('## toggle', id, this.viewSection, this.mapService.currentProject );
  }

  toggleMode() {
    let me = this;
    // slight delay to let Angular change detection catch up
    setTimeout ( ()=>{
      if ( me.uiModeSwitch ) {
        me.uiMode = 'simple';
      } else {
        me.uiMode = 'normal';
      }
    },100);
  }

  switchMode ( m:string = null ) {
    const mode = ''+m; // avoid recycling incoming mode objects
    const find = this.uiModes.find( f =>f.id == mode );
    if ( find ) {
      this.uiMode = mode;
      // console.log('## switching to', mode, this.uiModes );
    }
  }

  toggleQuickGuidePopup(screen:string, show:boolean) {
    this.toggleQuickGuide.next({screen:screen, show:show})
  }
  

  createPanel ( source:any, config:any = {} ) {
    let tmp:UiPanel = new UiPanel(config);
    tmp.controller = source;
    this.panels[tmp.id] = tmp;
    // console.log('## panel create',tmp, config);
    return tmp;
  }

  deletePanel ( panel:UiPanel = null ) {
    if ( panel && panel.id ) {
      delete this.panels[panel.id];
    }
    return null;
  }


  addPanel ( id:any = null, items:any = [], controller:any = null ) {
    if ( ! this.panelRegistry[id] ) {
      this.panelRegistry[id] = {
        id: id,
        class: '',
        label: '',
        show: false,
        items:items,
        props: [],
        plugin: controller
      };
      this.updateItems();
      if ( this.debug ) { console.log('!!!!!!!!', id, this.panelRegistry ); }
      return this.panelRegistry[id];
    }
    return null;
  }

  removePanel ( id:any = null ) {
    if ( this.panelRegistry[id] ) {
      delete this.panelRegistry[id];
      this.updateItems();
    }
    return null;
  }

  updatePanels() {
    this.panelsActive = [];
    Object.keys ( this.panelRegistry ).forEach ( key => {
      this.activePanels.push( this.panelRegistry[key] );
    });
  }

  updateItems() {
    this.activePanels = [];
    Object.keys ( this.panelRegistry ).forEach ( key => {
      this.activePanels.push( this.panelRegistry[key] );
    });
  }

  hideAll( id:any = null ) {
    this.activePanels.forEach ( item => {
      if ( id && item.id == id ) {
        // do nothing
      } else {
        let e = document.getElementById('ui_box_'+item.id);
        if ( e ) {
          e.style.display = 'none';
        }
      }
    });
  }

  showAll() {
    this.activePanels.forEach ( item => {
      let e = document.getElementById('ui_box_'+item.id);
      if ( e ) {
        e.style.display = 'block';
      }
    });
  }

  sidebarState:any = {
    showCursor: false,
    showCamera: false,
    size:0,
    oldSize:-1
  };

  sidebarHeightAdjust() {

    const a = this.fourD.activeUser;
    if ( !a ) return;
    
    this.sidebarState.showCursor = a['showCoordinates'];
    this.sidebarState.showCamera = a['showCameraCoordinates'];

    this.sidebarState.size = 15 + ( this.sidebarState.showCursor ? 30 : 0 ) + ( this.sidebarState.showCamera ? 30 : 0 );

    //console.log('%c #sidebar ', Constants._red, this.sidebarState, a );

    //if ( this.sidebarState.size !== this.sidebarState.oldSize ) {
      let main = document.getElementById('sidenav');
      if ( main ) {
        main.style.bottom = this.sidebarState.size+'px';
      }
      this.sidebarState.oldSize = this.sidebarState.size;
    //}

  }
}
